import { faPlus, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import { IComponentModal } from "./IModalComponent";

interface IModalInterface {
    setShow: React.Dispatch<React.SetStateAction<boolean>>;
    show: boolean;
    ModalComponent?: IComponentModal;
    children?: React.ReactElement;
    modalClose?: boolean;
    setModalClose?: React.Dispatch<React.SetStateAction<boolean>>;
}
function ModalComponent(props: IModalInterface) {
    const handleClose = () => {
        props.ModalComponent?.onClose?.();
        props.setShow(false);
        if (props.setModalClose) {
            props.setModalClose(false);
        }
    };

    return (
        <Modal
            show={props.show}
            onHide={handleClose}
            dialogClassName=""
            scrollable={props.ModalComponent?.scrollable}
            aria-labelledby="contained-modal-title-vcenter"
            size={props.ModalComponent?.size}
            backdrop={props.modalClose ? "static" : true}
            centered
        >
            {!props.ModalComponent?.noHeader && (
                <Modal.Header className="flex-wrap">
                    {props.ModalComponent?.customHeader ? (
                        props.ModalComponent.customHeader
                    ) : (
                        <Modal.Title
                            id="contained-modal-title-vcenter"
                            className={`w-100 d-flex ${
                                !props.ModalComponent?.IconHeader
                                    ? "justify-content-end"
                                    : "justify-content-between"
                            } align-itens-center`}
                        >
                            {props.ModalComponent?.IconHeader && (
                                <div className="d-flex align-itens-center">
                                    <FontAwesomeIcon
                                        icon={props.ModalComponent?.IconHeader}
                                        className="mr-2"
                                        size="lg"
                                    />
                                    {props.ModalComponent?.headerComponent}
                                </div>
                            )}
                            {props.modalClose && (
                                <OverlayTrigger
                                    overlay={
                                        <Tooltip id="ver-info-tooltip">
                                            Fechar
                                        </Tooltip>
                                    }
                                >
                                    <button
                                        type="button"
                                        className="close"
                                        onClick={handleClose}
                                    >
                                        <FontAwesomeIcon
                                            icon={faTimes}
                                            size="lg"
                                            color="red"
                                        />
                                    </button>
                                </OverlayTrigger>
                            )}
                            {props.ModalComponent?.collapseForm && (
                                <button
                                    className="btn btn-success font-weight-bold"
                                    type="button"
                                    data-toggle="collapse"
                                    data-target="#collapseForm"
                                    aria-expanded="false"
                                    aria-controls="collapseForm"
                                >
                                    <FontAwesomeIcon
                                        icon={faPlus}
                                        size="lg"
                                        className="mr-2"
                                    />{" "}
                                    Novo
                                </button>
                            )}
                        </Modal.Title>
                    )}
                </Modal.Header>
            )}

            {props.ModalComponent?.noBody && props.ModalComponent?.Component ? (
                <props.ModalComponent.Component />
            ) : (
                <Modal.Body
                    className={props.ModalComponent?.customBodyClasses}
                    id="modal-component-body"
                >
                    {props.children ??
                        props.ModalComponent?.Children ??
                        (props.ModalComponent?.Component && (
                            <props.ModalComponent.Component />
                        ))}
                </Modal.Body>
            )}

            {!props.ModalComponent?.noFooter && (
                <Modal.Footer>{props.ModalComponent?.footer}</Modal.Footer>
            )}
        </Modal>
    );
}
export default ModalComponent;
